// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2026 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

/**
 * 自建直播模块路由（对应 admin/src/views/marketing/live/）
 *
 * 注意：marketing.js 中已存在 path: 'broadcast'（微信原生小程序直播，商家维度），
 * 与之完全独立，本模块 path 为 'live'，避免路径与菜单冲突。
 *
 * 使用方式：在 admin/src/router/modules/marketing.js 的 children 数组末尾
 * 追加 `...liveRouter.children`，或直接 `import liveRouter from './live'` 后
 * 在 marketingRouter.children 中 push 其 children。
 */

import Layout from '@/layout';
var liveRouter = {
  path: '/marketing',
  component: Layout,
  redirect: '/marketing/live/room',
  name: 'MarketingLive',
  meta: {
    title: '直播',
    icon: 'clipboard'
  },
  children: [{
    path: 'live',
    component: function component() {
      return import('@/views/marketing/live/index');
    },
    name: 'MarketingLiveIndex',
    meta: {
      title: '自建直播',
      icon: ''
    },
    children: [{
      path: 'room',
      component: function component() {
        return import('@/views/marketing/live/room/index');
      },
      name: 'LiveRoomList',
      meta: {
        title: '直播间管理',
        icon: '',
        auth: ['admin-live-room-list']
      }
    }, {
      path: 'room/create/:id?',
      component: function component() {
        return import('@/views/marketing/live/room/create');
      },
      name: 'LiveRoomCreate',
      hidden: true,
      meta: {
        title: '新增直播间',
        icon: '',
        noCache: true,
        activeMenu: '/marketing/live/room',
        auth: ['admin-live-room-save']
      }
    }, {
      path: 'dashboard/:id?',
      component: function component() {
        return import('@/views/marketing/live/dashboard');
      },
      name: 'LiveDashboard',
      hidden: true,
      meta: {
        title: '直播中控台',
        icon: '',
        noCache: true,
        activeMenu: '/marketing/live/room',
        auth: ['admin-live-room-dashboard']
      }
    }, {
      path: 'goods',
      component: function component() {
        return import('@/views/marketing/live/goods/index');
      },
      name: 'LiveGoodsList',
      meta: {
        title: '直播商品库',
        icon: '',
        auth: ['admin-live-goods-list']
      }
    }, {
      path: 'roomProduct/:id?',
      component: function component() {
        return import('@/views/marketing/live/roomProduct/index');
      },
      name: 'LiveRoomProduct',
      meta: {
        title: '直播间商品',
        icon: '',
        auth: ['admin-live-room-product-list']
      }
    }, {
      path: 'anchor',
      component: function component() {
        return import('@/views/marketing/live/anchor/index');
      },
      name: 'LiveAnchorList',
      meta: {
        title: '主播管理',
        icon: '',
        auth: ['admin-live-anchor-list']
      }
    }, {
      path: 'danmaku',
      component: function component() {
        return import('@/views/marketing/live/danmaku/index');
      },
      name: 'LiveDanmakuList',
      meta: {
        title: '弹幕管理',
        icon: '',
        auth: ['admin-live-danmaku-list']
      }
    }, {
      path: 'luckyBag',
      component: function component() {
        return import('@/views/marketing/live/luckyBag/index');
      },
      name: 'LiveLuckyBagList',
      meta: {
        title: '福袋模板',
        icon: '',
        auth: ['admin-live-luckybag-list']
      }
    }, {
      path: 'luckyBag/create/:id?',
      component: function component() {
        return import('@/views/marketing/live/luckyBag/create');
      },
      name: 'LiveLuckyBagCreate',
      hidden: true,
      meta: {
        title: '新增福袋',
        icon: '',
        noCache: true,
        activeMenu: '/marketing/live/luckyBag',
        auth: ['admin-live-luckybag-save']
      }
    }, {
      path: 'luckyBag/record',
      component: function component() {
        return import('@/views/marketing/live/luckyBag/record');
      },
      name: 'LiveLuckyBagRecord',
      meta: {
        title: '福袋记录',
        icon: '',
        auth: ['admin-live-luckybag-record']
      }
    }, {
      path: 'coupon',
      component: function component() {
        return import('@/views/marketing/live/coupon/index');
      },
      name: 'LiveCouponList',
      meta: {
        title: '直播间优惠券',
        icon: '',
        auth: ['admin-live-coupon-list']
      }
    }, {
      path: 'statistics/:id?',
      component: function component() {
        return import('@/views/marketing/live/statistics/index');
      },
      name: 'LiveStatistics',
      meta: {
        title: '直播统计',
        icon: '',
        auth: ['admin-live-statistics']
      }
    }, {
      path: 'visitors/:id?',
      component: function component() {
        return import('@/views/marketing/live/visitors/index');
      },
      name: 'LiveVisitors',
      meta: {
        title: '观众列表',
        icon: '',
        auth: ['admin-live-viewer-list']
      }
    }, {
      path: 'setting',
      component: function component() {
        return import('@/views/marketing/live/setting/index');
      },
      name: 'LiveSetting',
      meta: {
        title: '直播设置',
        icon: '',
        auth: ['admin-live-setting']
      }
    }]
  }]
};
export default liveRouter;
export { liveRouter };